import { LayoutComponent } from "@jelly/lesson";
import config from "appConfig";

const components: LayoutComponent[] = [
  {
    variant: "blockContainer",
    data: {
      block: {
        type: "image",
        options: {
          src: `${config.ASSETS_URL}/01/17/principle/wall-50-hz--45-deg.svg`,
        },
      },
      styles: {
        padding: "2%",
      },
    },
  },
];

export default components;
